// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#selectdate{
    width: 0px;
    height: 0px;
  }

 #selectdate_box{
    width: 0px;
    height: 0px; 
 } 
 .small_torquespee{
    font-size: 60% !important;
 }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Coral/Driveanalysis_Coral/SecondPageCharts_Coral/Torquespeed_Coral.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;EACb;;CAED;IACG,UAAU;IACV,WAAW;CACd;CACA;IACG,yBAAyB;CAC5B","sourcesContent":["#selectdate{\n    width: 0px;\n    height: 0px;\n  }\n\n #selectdate_box{\n    width: 0px;\n    height: 0px; \n } \n .small_torquespee{\n    font-size: 60% !important;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
